var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[(_vm.screenType === 'desktop')?_c('lesson-item-desktop',{attrs:{"item":_vm.item,"class-id":_vm.classId,"course-id":_vm.courseId}}):_c('lesson-item-mobile',{attrs:{"item":_vm.item,"class-id":_vm.classId,"course-id":_vm.courseId}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }